export const SuccessCard = ({ score, max, viewAns, retake }) => {
    return (
        <div className="success-container">
            {score > max/2 ? (
                <div className="status-box">
                    <img
                        src="/svgs/success.svg"
                        alt=""
                        className="status-img"
                    />
                    <span className="status-msg">
                        Congratulations you have scored {score} / {max}
                    </span>
                </ div>
            ) : (
                <div className="status-box">
                    <img
                        src="/svgs/failed.svg"
                        alt=""
                        className="status-img"
                    />
                    <span className="status-msg">
                        Sorry, you have not passed this quiz. You scored {score} / {max}.
                    </span>
                </ div>
            )}
            <div className="next-action-box">
                <button 
                    className="next-action"
                    onClick={retake}
                >
                    Retake the test
                </button>
                <button 
                    className="next-action"
                    onClick={viewAns}
                >
                    View correct answers
                </button>
            </div>
        </div>
    );
}